import type { ReactNode } from 'react';

interface AppShellProps {
	children?: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
	return (
		<div className='bg-background text-foreground relative isolate flex min-h-dvh w-full flex-col overflow-x-hidden scroll-smooth bg-[radial-gradient(1200px_600px_at_12%_-10%,color-mix(in_oklch,var(--primary)_8%,transparent),transparent_60%),radial-gradient(900px_500px_at_110%_10%,color-mix(in_oklch,var(--accent)_35%,transparent),transparent_55%)]'>
			{/* Decorative mesh veil. Motion-safe so it pauses for users with reduced-motion preference. */}
			<div
				aria-hidden='true'
				className='pointer-events-none absolute inset-0 -z-10 opacity-50 motion-safe:animate-[pulse_8s_ease-in-out_infinite] [background:radial-gradient(circle_at_30%_20%,color-mix(in_oklch,var(--sidebar-primary)_18%,transparent),transparent_45%),radial-gradient(circle_at_80%_70%,color-mix(in_oklch,var(--sidebar-accent)_28%,transparent),transparent_50%)] motion-reduce:hidden'
			/>
			{children}
		</div>
	);
}
